import { mapState, mapGetters } from 'vuex'

export default {
    data() {
        return {
            withdrawalForm: {
                amount: null,
                currency: null,
                player_crypto_wallet_id: null,
            },
            amount: '', // This amount is the one is binding on the withdrawal amount v-model; It's for displaying only;
        }
    },
    computed: {
        ...mapState({
            cryptoCurrencyList: (state) =>
                state.settings.cryptoWalletAddressList,
            playerCryptoWallets: (state) =>
                state.themes['player-bank'].playerCryptoWallets,
            exchangeRateLoading: (state) =>
                state.themes.settings.exchangeRateLoading,
            getPlayerCryptoWalletsLoading: (state) =>
                state.themes['player-bank'].getPlayerCryptoWalletsLoading,
        }),
        ...mapGetters({
            getExchangeRateByFromAndTo:
                'themes/settings/getExchangeRateByFromAndTo',
        }),
        playerCurrencyCookie() {
            return this.$cookie.get('player')?.currency
        },
        cryptoExchangeRate() {
            if (this.exchangeRateLoading) return ''
            return (
                this.getExchangeRateByFromAndTo(
                    this.playerCurrencyCookie,
                    this.withdrawalForm.currency
                ) || 1
            )
        },
        withdrawalReceivingAmount() {
            if (!this.withdrawalForm.amount || this.exchangeRateLoading)
                return ''
            return this.formatCurrencyJS(
                this.withdrawalForm.amount * this.cryptoExchangeRate
            )
        },
    },
    watch: {
        playerCryptoWallets(value) {
            if (value.length > 0) {
                this.withdrawalForm.player_crypto_wallet_id = value[0].id
            }
        },
        cryptoCurrencyList(value) {
            if (value.length) {
                this.withdrawalForm.currency = value[0].code
            }
        },
    },
    mounted() {
        // Check if company crypto currency list exists
        // and set default crypto currency value
        if (!this.cryptoCurrencyList.length) {
            this.$store.dispatch('settings/getCryptoWalletAddressList')
        } else {
            this.withdrawalForm.currency = this.cryptoCurrencyList[0].code
        }

        // Set default selected player crypto wallet
        if (!this.playerCryptoWallets.length) {
            this.$store.dispatch('themes/player-bank/playerCryptoWallet')
        } else {
            this.withdrawalForm.player_crypto_wallet_id =
                this.playerCryptoWallets[0].id
        }
    },
    methods: {
        onWithdrawalAmountInput(inputAmount) {
            if (isNaN(inputAmount?.replace(/,/g, ''))) {
                this.withdrawalForm.amount = '0'
                return
            }
            this.amount = inputAmount
                ? Number.parseFloat(
                      inputAmount?.replace(/,/g, '')
                  )?.toLocaleString()
                : ''
            this.withdrawalForm.amount = this.amount
                ?.toString()
                ?.replace(/,/g, '')
        },
        onResetForm() {
            this.withdrawalForm = {
                currency: this.withdrawalForm.currency,
                amount: '',
                player_crypto_wallet_id: '',
            }
            this.amount = ''

            this.$refs.cryptoForm?.resetValidation()
        },
    },
}
